import {z} from 'zod';

export const PostMazdaPortalLoginApiResponseSchema = z
  .object({
    redirectUrl: z.string().url().nullable().optional(),
  })
  .nullable();

export type PostMazdaPortalLoginApiResponse = z.infer<typeof PostMazdaPortalLoginApiResponseSchema>;

export const PostMazdaPortalLoginApiArgSchema = z.object({
  authorizationProfileId: z.string(),
  destination: z.string(),
});

export type PostMazdaPortalLoginApiArg = z.infer<typeof PostMazdaPortalLoginApiArgSchema>;

export const MazdaWarrantyCodeSchema = z.object({
  code: z.string().nullish(),
  description: z.string().nullish(),
});

export type MazdaWarrantyCode = z.infer<typeof MazdaWarrantyCodeSchema>;

export const GetMazdaWarrantyAssemblyGroupsApiResponseSchema = z
  .object({
    assemblyGroups: z.array(MazdaWarrantyCodeSchema).nullish(),
  })
  .nullish();

export type GetMazdaWarrantyAssemblyGroupsApiResponse = z.infer<
  typeof GetMazdaWarrantyAssemblyGroupsApiResponseSchema
>;

export const GetMazdaWarrantySubAssemblyGroupsApiResponseSchema = z
  .object({
    subAssemblyGroups: z.array(MazdaWarrantyCodeSchema).nullish(),
  })
  .nullish();

export type GetMazdaWarrantySubAssemblyGroupsApiResponse = z.infer<
  typeof GetMazdaWarrantySubAssemblyGroupsApiResponseSchema
>;

export const GetMazdaWarrantySubAssemblyGroupsApiArgSchema = z.object({
  assemblyGroupCode: z.string(),
});

export type GetMazdaWarrantySubAssemblyGroupsApiArg = z.infer<
  typeof GetMazdaWarrantySubAssemblyGroupsApiArgSchema
>;

export const GetMazdaWarrantySymptomsApiResponseSchema = z
  .object({
    symptoms: z.array(MazdaWarrantyCodeSchema).nullish(),
  })
  .nullish();

export type GetMazdaWarrantySymptomsApiResponse = z.infer<
  typeof GetMazdaWarrantySymptomsApiResponseSchema
>;

export const GetMazdaWarrantySymptomsApiArgSchema = z.object({
  assemblyGroupCode: z.string(),
});

export type GetMazdaWarrantySymptomsApiArg = z.infer<typeof GetMazdaWarrantySymptomsApiArgSchema>;

export const GetMazdaWarrantyDamagesApiResponseSchema = z
  .object({
    damages: z.array(MazdaWarrantyCodeSchema).nullish(),
  })
  .nullish();

export type GetMazdaWarrantyDamagesApiResponse = z.infer<
  typeof GetMazdaWarrantyDamagesApiResponseSchema
>;

export const GetMazdaWarrantyDamagesApiArgSchema = z.object({
  assemblyGroupCode: z.string(),
});

export type GetMazdaWarrantyDamagesApiArg = z.infer<typeof GetMazdaWarrantyDamagesApiArgSchema>;

export const GetMazdaWarrantyLocationsApiResponseSchema = z
  .object({
    locations: z.array(MazdaWarrantyCodeSchema).nullish(),
  })
  .nullish();

export type GetMazdaWarrantyLocationsApiResponse = z.infer<
  typeof GetMazdaWarrantyLocationsApiResponseSchema
>;

export const GetMazdaWarrantyLocationsApiArgSchema = z.object({
  assemblyGroupCode: z.string(),
  subAssemblyGroupCode: z.string(),
});

export type GetMazdaWarrantyLocationsApiArg = z.infer<typeof GetMazdaWarrantyLocationsApiArgSchema>;

export const GetMazdaWarrantyCausalPartsApiResponseSchema = z
  .object({
    causalParts: z.array(MazdaWarrantyCodeSchema).nullish(),
  })
  .nullish();

export type GetMazdaWarrantyCausalPartsApiResponse = z.infer<
  typeof GetMazdaWarrantyCausalPartsApiResponseSchema
>;

export const GetMazdaWarrantySubletsApiResponseSchema = z
  .object({
    sublets: z.array(MazdaWarrantyCodeSchema).nullish(),
  })
  .nullish();

export type GetMazdaWarrantySubletsApiResponse = z.infer<
  typeof GetMazdaWarrantySubletsApiResponseSchema
>;
